import React, { useEffect } from 'react';
import { translate } from '../../Services/translation';
import { query as queryAddresses } from '../../Actions/Address.action';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { breakpoint } from '../../styling/mixins/breakpoints';
import AddressListItemDesktop from './ui/AddressListItemDesktop';
import AddressListItemMobile from './ui/AddressListItemMobile';
import styled from 'styled-components';
import { fontFamilyBold, text } from '../../styling/mixins/typography';
import { hideFor, showFor } from '../../styling/utils/visibility';
import { getColor } from '../../styling/mixins/colors';
import { cells, grid } from '../../styling/utils/grid';
import Button from '../Button';
import SkeletonListItemDesktop from './ui/SkeletonListItemDesktop';
import SkeletonListItemMobile from './ui/SkeletonListItemMobile';
import EditorString from '../EditorString/EditorString';

const StyledMyPagesAddresses = styled.div`
  grid-column: span 3;

  .title {
    margin-bottom: 0.8rem;
  }

  .description {
    ${text('large')}
    max-width: 768px;
    margin-bottom: 1.6rem;

    ${breakpoint('large')} {
      margin-bottom: 2.4rem;
    }
  }

  .list-mobile {
    ${hideFor('large')}
    margin-bottom: 0.8rem;

    ${breakpoint('medium')} {
      margin-bottom: 1.6rem;
    }
  }

  .list-desktop {
    ${showFor('large')}
    border: 1px solid ${getColor('grey', 300)};
    border-radius: 4px;
    margin-bottom: 4rem;
  }

  .header {
    ${grid}
    ${cells(5)}
    padding: 0.8rem;
    border-bottom: 1px solid ${getColor('grey', 300)};
    gap: 1.6rem;
    background-color: ${getColor('white')};

    &__span {
      ${text('large')}
      ${fontFamilyBold}
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
`;

const MyPagesUsers = ({ introText }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { addresses } = useTypedSelector<any>((state) => state.myPage);
  const addressList = addresses.list;
  useEffect(() => {
    dispatch(queryAddresses());
  }, []);
  return (
    <StyledMyPagesAddresses>
      <h1 className="title">{translate('mypage.address.title')}</h1>
      <div className="description">
        <EditorString value={introText.value} />
      </div>
      <ul className="list-mobile">
        <SkeletonListItemMobile items={3} cells={2} loading={!addressList} />
        {addressList &&
          addressList
            .filter((address) => address.addressType !== "Billing")
            .map((address) => (
              <AddressListItemMobile address={address} key={address.systemId} />
            ))}
      </ul>
      <ul className="list-desktop">
        <div className="header">
          <p className="header__span">{translate('mypage.address.address')}</p>
          <p className="header__span">{translate('mypage.address.zipcode')}</p>
          <p className="header__span">{translate('mypage.address.city')}</p>
          <p className="header__span">{translate('mypage.address.country')}</p>
        </div>
        <SkeletonListItemDesktop items={5} cells={5} loading={!addressList} />
        {addressList &&
          addressList
            .filter((address) => address.addressType !== "Billing")
            .map((address) => (
              <AddressListItemDesktop address={address} key={address.systemId} />
            ))}
      </ul>
      <Button btnType="primary" btnSize="large" onClick={() => navigate('add')}>
        {translate('mypage.address.addaddress')}
      </Button>
    </StyledMyPagesAddresses>
  );
};
export default MyPagesUsers;
